import {
  PublishingErrorCode,
  TenantPublishingError,
} from './types';

type ErrorLike = { message?: unknown; details?: unknown };

const APPLICATION_CODES = new Set<PublishingErrorCode>([
  'UNAUTHENTICATED', 'FORBIDDEN', 'INVALID_ARGUMENT', 'NOT_FOUND',
  'DRAFT_VERSION_CONFLICT', 'IDEMPOTENCY_CONFLICT', 'PUBLISH_VALIDATION_FAILED',
  'UNSUPPORTED_SCHEMA', 'INTERNAL',
]);

const asRecord = (value: unknown): Record<string, unknown> | undefined =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : undefined;

export const normalizePublishingError = (error: unknown): TenantPublishingError => {
  if (error instanceof TenantPublishingError) return error;
  const source = asRecord(error) as ErrorLike | undefined;
  const details = asRecord(source?.details);
  const applicationCode = details?.applicationCode;
  const code = typeof applicationCode === 'string' && APPLICATION_CODES.has(applicationCode as PublishingErrorCode)
    ? applicationCode as PublishingErrorCode
    : 'UNKNOWN';
  const message = typeof source?.message === 'string' && source.message.trim()
    ? source.message.replace(/^Firebase:\s*/i, '')
    : 'The publishing request could not be completed.';
  return new TenantPublishingError(code, message, details);
};
